import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.DryingTray.WetSoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.WetSoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.ConstantDrySoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.ConstantDrySoilAndContainerMass`]: wrap([
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTray.DryMassReadings.DrySoilMass`]: wrap([
    `${prefix}.DryingTray.ContainerMass`,
    `${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`,
  ]),

  [`${prefix}.DryingTrays.WetSoilMass`]: wrap([
    `${prefix}.DryingTrays.ContainerMass`,
    `${prefix}.DryingTrays.WetSoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTrays.ConstantDrySoilMass`]: wrap([
    `${prefix}.DryingTrays.ContainerMass`,
    `${prefix}.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTrays.ConstantDrySoilAndContainerMass`]: wrap([
    `${prefix}.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.DryingTrays.DryMassReadings.DrySoilMass`]: wrap([
    `${prefix}.DryingTrays.ContainerMass`,
    `${prefix}.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.Measurements.TotalDryMass`]: wrap([
    `${prefix}.DryingTrays.ContainerMass`,
    `${prefix}.DryingTrays.DryMassReadings.DrySoilAndContainerMass`,
  ]),
  [`${prefix}.Measurements.TotalWetMass`]: wrap([
    `${prefix}.DryingTrays.ContainerMass`,
    `${prefix}.DryingTrays.WetSoilAndContainerMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
